import React, {useContext, useEffect, useMemo} from 'react';
import Layout from './Layout';
import {EmptyState, Loader} from '../../../components';
import {placeholder} from '../../../assets/images/images';
import {useQuery} from 'react-query';
import {fetchAuthenticationDetails} from '../../../requests/queries/easyAuth';
import {useNavigate, useParams} from 'react-router-dom';
import {PageContext} from '../../../helpers/context';
import {isObjectEmpty} from '../../../helpers/isObjectEmpty';
import {ExpandImageToggle} from '../components';

function Bio() {
  const {slug} = useParams();
  const navigate = useNavigate();
  const {data: authData, isLoading} = useQuery(
    ['auth-bio', slug],
    () => fetchAuthenticationDetails({authenticationId: slug, type: 'summary'}),
    {
      retry: 1,
    },
  );

  const session_summary = useMemo(
    () => !isLoading && authData,
    [authData, isLoading],
  );

  const VERIFICATION = session_summary?.data?.Verification;
  const USER_DATA = session_summary?.data?.auth;

  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('verifications');
  }, [setPageName]);

  const detailsUrl =
    USER_DATA?.previous_id && USER_DATA?.type !== 'authentication'
      ? `/verifications/bio-data/${USER_DATA?.previous_id}`
      : `/authentications/${USER_DATA?.previous_id}/bio-data`;

  const isEmpty =
    !USER_DATA?.image_url &&
    !USER_DATA?.selfie_url &&
    (!USER_DATA?.previous_id || USER_DATA?.previous_id === slug);

  const Header = () => (
    <div className="flex justify-between">
      <p className="font-medium text-grey">Registered Liveness</p>
      <p className="text-xs text-white bg-green-700 rounded-full flex justify-center items-center px-2 ">
        {VERIFICATION?.reference_id || '---'}
      </p>
    </div>
  );

  return (
    <Layout>
      {isLoading && !session_summary ? (
        <Loader height={45} />
      ) : !isLoading &&
        ((session_summary && !session_summary?.data) ||
          session_summary === undefined ||
          isEmpty) ? (
        // eslint-disable-next-line
        <>
          <Header />
          <EmptyState
            body="No Bio data found for this verification"
            noBtn
            height={50}
          />
        </>
      ) : (
        <div className="bg-white min-h-[660px]">
          <div>
            <div className="flex flex-col">
              {!isObjectEmpty(USER_DATA) && (
                <div className="flex flex-col gap-4">
                  <div className="w-full flex flex-col">
                    <Header />
                    {USER_DATA?.image_url &&
                      !USER_DATA?.image_url.endsWith('.webm') && (
                        <div className="relative my-4 w-full flex items-center justify-center">
                          <img
                            src={USER_DATA?.image_url || placeholder}
                            alt=""
                            className="w-full mt-2 object-cover max-h-[292px] rounded-lg"
                            id="id-url"
                          />
                          <ExpandImageToggle
                            imgUrl={USER_DATA?.image_url || placeholder}
                            id="id-url"
                          />
                        </div>
                      )}

                    {USER_DATA?.previous_id && (
                      <p
                        className="text-sm my-3 underline text-brandBlue cursor-pointer hover:opacity-70 ease-in-out"
                        onClick={() => navigate(detailsUrl)}
                      >
                        See registration details
                      </p>
                    )}
                  </div>
                  {USER_DATA?.selfie_url && (
                    <div className="h-[1px] w-full bg-grey5" />
                  )}
                  {USER_DATA?.selfie_url && (
                    <div>
                      <p className="font-medium text-grey">Authentication</p>

                      {USER_DATA?.selfie_url &&
                        !USER_DATA?.selfie_url.endsWith('.webm') && (
                          <div className="relative my-4 w-full flex items-center justify-center">
                            <img
                              src={USER_DATA?.selfie_url || placeholder}
                              alt=""
                              className="w-full mt-2 object-cover max-h-[292px] rounded-lg"
                              id="selfie_url"
                            />
                            <ExpandImageToggle
                              imgUrl={USER_DATA?.selfie_url || placeholder}
                              id="selfie_url"
                            />
                          </div>
                        )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Bio;
